import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=41af2202&scoped=true&"
import script from "./Option.vue?vue&type=script&lang=ts&"
export * from "./Option.vue?vue&type=script&lang=ts&"
import style0 from "./Option.vue?vue&type=style&index=0&id=41af2202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af2202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\rafael\\Github\\MultiSelect\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41af2202')) {
      api.createRecord('41af2202', component.options)
    } else {
      api.reload('41af2202', component.options)
    }
    module.hot.accept("./Option.vue?vue&type=template&id=41af2202&scoped=true&", function () {
      api.rerender('41af2202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiSelect/Option.vue"
export default component.exports